import { useState, useEffect } from 'react';
import { EditRequestForm } from 'Components';
import { useAllCategories, useProjectDetails, useStatuses } from 'Hooks';
import { TFunction } from 'react-i18next';

export function useEditResquestForm(t: TFunction<'forms'>, isAdmin: boolean) {
    const [editRequestForm, setEditRequestForm] = useState(EditRequestForm(t, isAdmin));

    const { projectDetails } = useProjectDetails();
    const { categories } = useAllCategories();
    const { statuses } = useStatuses();

    useEffect(() => {
        setEditRequestForm(EditRequestForm(t, isAdmin)); // If weird form behaviors, might be because of this one ! :)
    }, [isAdmin, t]);

    useEffect(() => {
        setEditRequestForm(prevState => ({
            ...prevState,
            category: {
                ...prevState["category"],
                options: categories.map(category => ({ key: category.categoryId, value: category.description }))
            },
            status: {
                ...prevState["status"],
                options: statuses.map(status => ({ key: status, value: status }))
            },
            contract: {
                ...prevState["contract"],
                options: projectDetails.map(projectDetail => ({ key: projectDetail.projectNumber, value: projectDetail.projectNumber }))
            }
        }));
    }, [setEditRequestForm, projectDetails, categories, statuses]);

    return { editRequestForm, setEditRequestForm };
}